// Timing out a write does not cancel its server-side effect; callers must reconcile it.
export async function withRequestDeadline<T>(promise: Promise<T>, milliseconds = 12_000): Promise<T> {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  return Promise.race([promise, new Promise<never>((_, reject) => {
    timeout = setTimeout(() => reject(new Error('请求结果暂未确认')), milliseconds);
  })]).finally(() => clearTimeout(timeout));
}
